<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view></router-view>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar'
export default {
  name: 'App',
  components:{
    NavBar,
  }
}
</script>

<style>
#app{
  min-width: 1400px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue